module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Black-da55a2f40cef148469eeed563c842e55.ttf";